
import { defineComponent } from 'vue';
import store from '@/store';
import { useRouter } from 'vue-router';

import Navbar from '@/components/Navbar.vue';
import SubredditSidebar from '@/components/SubredditSidebar.vue';
import InfoSidebar from '@/components/InfoSidebar.vue';

import { Notification } from '@/typings';

export default defineComponent({
	components: {
		Navbar,
		SubredditSidebar,
		InfoSidebar,
	},
	setup() {
		document.title = 'Notifications | (not) reddit';
		const router = useRouter();
		store.notifications.state.newNotifs = false;

		function handleNotifClick(notif: Notification) {
			if (!notif.url?.length) return;
			router.push(notif.url);
		}
		return {
			store,
			router,
			handleNotifClick,
		};
	},
});
